import { ENDPOINTS } from "@horseed/shared/endpoints";
import { API_BASE_URL, apiRequest } from "./http";

const { CART } = ENDPOINTS;

// POST /api/v1/Cart/add - body: { userId, items: [{ itemId, quantity }] }
export async function addToCart(userId, items) {
  const json = await apiRequest(`${API_BASE_URL}${CART.ADD}`, {
    method: "POST",
    body: JSON.stringify({ userId, items }),
  });
  return json?.data ?? null;
}

// GET /api/v1/Cart/get?userId={userId}
export async function getCart(userId) {
  const cartRequestUrl = userId
    ? `${API_BASE_URL}${CART.GET}?userId=${encodeURIComponent(userId)}`
    : `${API_BASE_URL}${CART.GET}`;
  const json = await apiRequest(cartRequestUrl);
  return json?.data ?? null;
}

// POST /api/v1/Cart/update - body: { userId, items: [{ itemId, quantity }] }
export async function updateCart(userId, items) {
  const json = await apiRequest(`${API_BASE_URL}${CART.UPDATE}`, {
    method: "POST",
    body: JSON.stringify({ userId, items }),
  });
  return json?.data ?? null;
}

// POST /api/v1/Cart/remove - body: { userId, items: [{ itemId, quantity }] }
export async function removeFromCart(userId, items) {
  const json = await apiRequest(`${API_BASE_URL}${CART.REMOVE}`, {
    method: "POST",
    body: JSON.stringify({ userId, items }),
  });
  return json?.data ?? null;
}

// POST /api/v1/Cart/clear - body: { userId }
export async function clearCart(userId) {
  const json = await apiRequest(`${API_BASE_URL}${CART.CLEAR}`, {
    method: "POST",
    body: JSON.stringify({ userId }),
  });
  return json?.data ?? null;
}
